import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setLoginData, isLoginAuth } from "utils/login";
import { axAppSRCM } from "services/base";
import { lStorage } from "../../../utils/storage";

function Launch() {
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const navigateTo = urlParams.get("navigateTo");

  const getRedirectPath = useCallback(() => {
    let path = "";
    switch (navigateTo) {
      case "satsang-event":
        path = "/mobile/satsang-event";
        break;
      case "satsang-pwa":
        path = "/pwa/launch";
        break;
      default:
        path = "/mobile/events";
    }
    return path;
  }, [navigateTo]);

  useEffect(() => {
    const redirectTo = getRedirectPath();
    // navigate("/mobile/events");
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "REQUEST_TOKEN" })
      );
    }

    window.addEventListener("message", async (message) => {
      if (message.data.token) {
        lStorage.set("authInfo", { srcmToken: message.data.token });
        await axAppSRCM
          .get("/api/v2/me/?fields=id,user_firebase_uid,name,user_email,city")
          .then((res) => {
            const user = {};
            if (res?.data?.results.length > 0) {
              const myInfo = res?.data?.results[0];
              user.srcmToken = message.data.token;
              user.name = myInfo.name;
              user.email = myInfo.user_email;
              user.loginUser = myInfo;
              user.expired = false;
              lStorage.set("authInfo", user);
              setLoginData(user);
              setTimeout(() => {
                navigate(redirectTo);
              }, 2000);
            }
          });
      } else if (isLoginAuth()) {
        navigate(redirectTo);
      }
    });
  }, [navigate]);

  return (
    <div className="lds-roller-wrapper">
      <div className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
}

export default Launch;
